import axios from 'axios';
import parseCookie from '../utils/parseCookie';
import isNode from '../utils/isNode';

export default function (ctx) {
    const cookies = parseCookie(!isNode ? (document.cookie || '') : (ctx.req.headers.cookie || ''));
    ctx.$axios = axios.create({
        baseURL: !isNode ? '/' : 'http://127.0.0.1:7001/',
        headers: !isNode ? {
            'x-csrf-token': cookies.csrfToken || '',
            token: cookies.token || '',
        } : {
            'user-agent': ctx.req.headers['user-agent'] || '',
            cookie: ctx.req.headers.cookie || '',
            'x-csrf-token': cookies.csrfToken || '',
            token: cookies.token || '',
        },
    });

    // 对返回数据检查的中间件
    ctx.$axios.interceptors.response.use((response) => {
        if (response.data.result === 'SUCCESS') {
            return response.data;
        }
        return Promise.reject(response);
    });

    // 当服务出错时设置错误页信息（但是还是会抛出错误，各页面需要自行处理catch住错误）
    ctx.$axios.interceptors.response.use(data => data, (err) => {
        if (err.status === 200) {
            ctx.error({
                message: '网络错误\n稍后再试',
            });
        } else {
            ctx.error({
                statusCode: err.status,
                message: err.data.message,
            });
        }
        return Promise.reject(err);
    });
}
